import * as React from 'react';
import styled from 'styled-components';
import { withProps } from '../../../theme/styled-components';
import { rem, rgba } from 'polished';
import { FlexBetween } from '../Flexbox/Flexbox';
import ProductVariantValue from './ProductVariantValue/ProductVariantValue';
import { Variant as VariantTypes } from './types';

export interface Props {
  selectedItem: VariantTypes | null;
  selectIsOpened: boolean;
  handleSelectVariant: () => void;
  items: VariantTypes[];
  onClickItem: (item: VariantTypes) => void;
  className?: string;
  productName: string;
}

interface ProductVariantValuesProps {
  active: boolean;
}

export class ProductVariantSelect extends React.Component<Props> {
  render() {
    const {
      handleSelectVariant,
      selectedItem,
      items,
      onClickItem,
      className,
      productName,
    } = this.props;
    return (
      <ProductVariantSelectWrapper
        active={this.props.selectIsOpened}
        className={className}
      >
        <ProductVariantSelected onClick={handleSelectVariant}>
          <ProductVariantSelectText>{productName}</ProductVariantSelectText>
          <DropdownArrow src={'/images/arrow_triangle.svg'} />
        </ProductVariantSelected>
        <ProductVariantValuesWrapper>
          {items &&
            items.length > 0 &&
            items.map(item => {
              return (
                <ProductVariantValue
                  key={`productVariantItem: ${item.good_id}`}
                  item={item}
                  name={productName}
                  onClickItem={onClickItem}
                />
              );
            })}
        </ProductVariantValuesWrapper>
      </ProductVariantSelectWrapper>
    );
  }
}

const ProductVariantValuesWrapper = styled.div`
  margin-top: ${rem(5)};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) =>
    `0 ${rem(1)} ${rem(5)} ${rgba(theme.colors.black, 0.16)}`};
  background: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: ${rem(44)};
  width: 90%;
  overflow: hidden;
  z-index: ${({ theme }) => theme.index.priorityContent};
  ${({ theme }) => theme.media.m`
    width: 100%;
  `};
`;

const DropdownArrow = styled.img`
  width: ${rem(8)};
  height: ${rem(5)};
`;

const ProductVariantSelectText = styled.span`
  ${({ theme }) => theme.media.m`
    font-size: ${theme.fontSizeXS};
  `};
`;

const ProductVariantSelected = styled(FlexBetween)`
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${rem(10)} ${rem(15)};
  max-width: 60%;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  ${({ theme }) => theme.media.m`
    max-width: 100%;
  `};
`;

const ProductVariantSelectWrapper = withProps<ProductVariantValuesProps>()(
  styled.div,
)`
  margin-bottom: ${rem(30)};
  position: relative;
  ${ProductVariantSelected} {
    border: ${rem(1)} solid ${({ active, theme }) =>
  active ? `${theme.colors.primary}` : `${theme.colors.borderColor}`};
    box-shadow: ${({ active, theme }) =>
      active ? `0 0 ${rem(5)} ${theme.colors.primary}` : 'none'};
  }
  ${ProductVariantValuesWrapper} {
    display: ${({ active }) => (active ? 'block' : 'none')};
  }
`;
